import React from 'react';

const Hero: React.FC = () => {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="relative bg-gradient-to-br from-soez-blue to-soez-blue-dark text-white pt-40 pb-24 px-8 overflow-hidden">
      {/* Background decorations */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-0 w-96 h-96 bg-soez-orange/10 rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-soez-orange/10 rounded-full blur-3xl" />
      </div>

      <div className="max-w-7xl mx-auto text-center relative z-10">
        <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight animate-fade-in-up">
          Enterprise Chats <span className="text-soez-orange">Simplified</span>
        </h1>

        <p className="text-xl md:text-2xl mb-8 opacity-95 max-w-3xl mx-auto animate-fade-in-up animation-delay-100">
          Secure, intelligent, and effortless messaging designed for organizations that demand complete control and uncompromising privacy.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mt-8 animate-fade-in-up animation-delay-200">
          <button
            onClick={() => scrollToSection('contact')}
            className="bg-soez-orange text-white px-8 py-4 rounded-md font-semibold text-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
          >
            Schedule a Demo
          </button>
          <button
            onClick={() => scrollToSection('features')}
            className="bg-transparent text-white px-8 py-4 border-2 border-white rounded-md font-semibold text-lg hover:bg-white hover:text-soez-blue transition-all duration-300"
          >
            Explore Features
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
